<template>
  <div>
    <div class="navbar" :style="{ background:bgColor}">
      <!-- <div class="left" @click="handleBack">{{ isBack ? '222' : '111' }}</div> -->
      <div class="left">
        <img v-if="type == 0" class="logo" src="@/assets/navbar/logo_white.png" alt="" @click="handleGoHome">
        <img v-else class="logo" src="@/assets/navbar/logo_blue.png" alt="" @click="handleGoHome">
      </div>
      <div class="right">
        <img v-if="type == 0" class="Internet" :src="leftImg" alt="" @click="handleOpenBar">
        <img  v-else class="Internet" :src="rightImg" alt="" @click="handleOpenBar">
      </div>
    </div>
    <UserDrawer v-model="showUserDrawer" />
  </div>
</template>
<script>
import UserDrawer from '@/components/UserCenter/Drawer.vue'
export default {
  name: 'NavBar',
  props:{
    isBack:{
      type:Boolean,
      default:false
    },
    type:{
      type:Number,
      default:0
    },
    bgColor:{
      type:String,
      default:'#1A3232'
    }
  },
  components:{
    UserDrawer
  },
  data(){
    return {
      showUserDrawer:false,
      rightImg:require('@/assets/navbar/Frame_blue.png'),
      leftImg:require('@/assets/navbar/Frame_white.png'),
    }
  },
  methods:{
    handleBack(){
      if( this.isBack ){
        this.$router.push('/')
      }
    },
    // 右侧菜单按钮：打开左侧个人中心抽屉（不再弹出顶部 Bar）
    handleOpenBar(){
      this.showUserDrawer = true
    },
    // 点击顶部 logo 回到首页
    handleGoHome(){
      this.$router.push('/').catch(() => {})
    },
    // 打开左侧个人中心抽屉
    handleOpenUser(){
      this.showUserDrawer = true
    },
  }
}
</script>
<style lang="scss" scoped>
  .navbar{
    width: 100%;
    padding: 0 1rem;
    height: 2.75rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .left{
      .logo{
        width: 4.0625rem;
        height: 1.5rem;
      }
    }
    .right{
      display: flex;
      gap: 0.5rem;
      .Internet{
        width: 1.5rem;
        height: 1.5rem;
        display: block;
      }
    }
  }
</style>
